import { useState } from "react";

export function useQuantityAdjust(
  maxItems: number,
  maxItemsRandom: number,
  limitEdition: boolean,
  randomMarker: boolean
) {
  const [quantity, setQuantity] = useState(1);

  const increment = () => {
    if (quantity === maxItems && limitEdition === true) return;
    if (quantity === maxItemsRandom && randomMarker === true) return;
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity === 1) return;
    setQuantity(quantity - 1);
  };

  return {
    models: {
      quantity,
      maxItems,
    },
    operations: {
      increment,
      decrement,
    },
  };
}
